import $ from 'jquery';
$('.strategy-tools .link-item').hover(onIn, onOut)
function onIn() {
	$(this).parent().parent().find('.strategy-tools-hidden').addClass("active");
}
function onOut() {
	$(this).parent().parent().find('.strategy-tools-hidden').removeClass("active");
}